import HotelContacts from './HotelContacts'
import './HotelContacts.css'

export default HotelContacts



// WEBPACK FOOTER //
// ./src/components/HotelContacts/index.js